import './GanttChartTooltip.css';
export var ganttChartTooltipCSS = '_1v8s3xl0-3-8-0';